export const dynamicSort = (property, order) => {
    const sortOrder = 1;
    return function (a, b) {
        let result = 0;
        const first = a[property] && !isNumeric(a[property])
            ? a[property].toLowerCase()
            : a[property];
        const second = b[property] && !isNumeric(b[property])
            ? b[property].toLowerCase()
            : b[property];
        if (order === 'ascending') {
            const secondConditon = first > second ? 1 : 0;
            result = first < second ? -1 : secondConditon;
        }
        else {
            const secondConditon = first < second ? 1 : 0;
            result = first > second ? -1 : secondConditon;
        }
        return result * sortOrder;
    };
};
function isNumeric(value) {
    if (!isNaN(Number(value))) {
        return !isNaN(Number(value));
    }
    else {
        return false;
    }
}
